module.exports = __webpack_public_path__ + "static/media/active_compare.2d6edce1.svg";